import script from "./Company.vue?vue&type=script&setup=true&lang=ts"
export * from "./Company.vue?vue&type=script&setup=true&lang=ts"

import "./Company.vue?vue&type=style&index=0&id=042c673c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-042c673c"]])

export default __exports__